// Single API base for the whole app.
// - Preview (…preview.emergentagent.com): use the configured backend URL.
// - Production (custom domain or *.emergent.host): use the same origin —
//   ingress routes /api to the backend there, which avoids cross-origin blocks
//   when the site is served from a domain the build didn't know about.
const isPreviewHost =
  typeof window !== "undefined" && window.location.hostname.includes("emergentagent.com");

const API = isPreviewHost
  ? process.env.REACT_APP_BACKEND_URL
  : typeof window !== "undefined"
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export default API;
